'use strict';

angular.module('widgets.buyer', ['adf.provider', 'app.core'])
	.service('buyerWidgetsService', buyerWidgetsService);

function buyerWidgetsService($http, URLS, WEEKLY_LOG_ITEM_FIELDS) {
	return {
		
	};
}